import React from "react";
import './styles.scss';
import './animation.scss';

import { easeIn, motion } from "framer-motion"

const Banner = () => {

    return (
        <section className="BannerConteiner">
            <motion.div 
            initial={{opacity:0,scale:0.5}}
            animate={{opacity:1,scale:1}}
            transition={{duration:0.8,ease: [0, 0.71, 0.2, 1.01]}}
            className="logo">
                <img src="/images/SosaFine.png" alt="Fesosa Icon"  width={350}/>
                <h2>Full-stack Developer</h2>
            </motion.div>
            <motion.div  
            initial={{opacity:0,scale:0.5}}
            animate={{opacity:1,scale:1}}
            transition={{duration:0.8,ease: [0, 0.71, 0.2, 1.01]}}
            className="social">
                <a href="https://github.com/FeSoSa" target="_blank">
                    <img src="https://skillicons.dev/icons?i=github" alt="GitHub"/>
                </a>
                <a href="https://www.linkedin.com/in/fesosa/" target="_blank">
                    <img src="https://skillicons.dev/icons?i=linkedin" alt="Linkedin"/>
                </a>
                <a href="https://www.instagram.com/felipe.jsx/" target="_blank">
                    <img src="https://skillicons.dev/icons?i=instagram" alt="Instagram"/>
                </a>
            </motion.div>

        </section>
    );
}
export default Banner